$(document).ready(function () {
    console.log("Doc ready");

    // Inisialisasi Ulang Flickity Setelah Video Dimuat
    if ($('.Slideshow__Carousel').hasClass('flickity-enabled')) {
        let flkty = window.myGlobalFlickity

        // Fungsi untuk update height secara konsisten
        function updateViewportHeight(newHeight) {
            const viewport = document.querySelector('.Slideshow__Carousel .flickity-viewport');
            // Setel ke tinggi yang diinginkan atau ambil dari slide tertinggi
            viewport.style.height = newHeight + 'px';
            // Paksa update Flickity
            if (flkty) {
                flkty.resize();
            }
        }

        // Panggil saat video dimuat
        if ($(window).width() > 1140) {
            let newHeight = 0
            $('.Slideshow__Carousel video.hidden-phone').each((i, v) => {
                setTimeout(() => {
                    // console.log('outerheight desktop', $(v).outerHeight())
                    newHeight = $(v).outerHeight()
                    v.addEventListener('loadedmetadata', updateViewportHeight($(v).outerHeight()));
                    v.addEventListener('loadeddata', updateViewportHeight($(v).outerHeight()));
                    v.addEventListener('canplay', updateViewportHeight($(v).outerHeight()));
                }, 500)
            });
        }
        else {
            let newHeight = 0
            $('.Slideshow__Carousel video.hidden-desk').each((i, v) => {
                setTimeout(() => {
                    // console.log('outerheight mobile', $(v).outerHeight())
                    newHeight = $(v).outerHeight()
                    v.addEventListener('loadedmetadata', updateViewportHeight($(v).outerHeight()));
                    v.addEventListener('loadeddata', updateViewportHeight($(v).outerHeight()));
                    v.addEventListener('canplay', updateViewportHeight($(v).outerHeight()));
                }, 500)
            });
        }
    }

    if ($(window).width() > 1140) {
        setTimeout(function () {
            var currency = $(".bacurr-cur-blocker");
            $(".hide-desk").append(currency);
            $(".bacurr-dropdownChoices").addClass("bdd-white");
        }, 3500);
    } else if ($(window).width() < 640) {
        console.log("tes");
    }

    if ($(window).width() < 700) {
        $(".PageHeader__ImageWrapper").css({
            transform: "none !important",
        });
    }

    if (window.screen.width >= 1024) {
        $(".collection-anim__container").mouseover(function () {
            $(this).css("flex", "2");
            $(this).find(".collection-anim__tulisan").css("left", "50%");
            let siblings = $(this).siblings();
            $(siblings).each(function (i, v) {
                $(this).css("flex", "1");
                $(this).find(".collection-anim__tulisan").css("left", "60%");

            });

        });
    }

    $("#filter-collection").click(function () {
        $("body").css("overflow", "hidden");
        $("#sidebar-filter").addClass("Drawer--show");
        $(".PageOverlay").addClass("is-visible");
    });

    $("#close-filter").click(function () {
        $("body").css("overflow", "auto");
        $("#sidebar-filter").removeClass("Drawer--show");
        $(".PageOverlay").removeClass("is-visible");
    });

    $(".PageOverlay").click(function () {
        $("body").css("overflow", "auto");
        $("#sidebar-filter").removeClass("Drawer--show");
        $("#sidebar-description").removeClass("Drawer--show");
        $(".PageOverlay").removeClass("is-visible");
    });

    var acc = document.getElementsByClassName("accordion");
    var i;

    for (i = 0; i < acc.length; i++) {
        acc[i].addEventListener("click", function () {
            this.classList.toggle("active");
            var panel = this.nextElementSibling;
            //     panel.classList.toggle('panel-active')
            if (panel.style.maxHeight) {
                panel.style.maxHeight = null;
            } else {
                panel.style.maxHeight = panel.scrollHeight + "px";
            }
        });
    }

    var icc = document.getElementsByClassName("samping");
    var o;

    for (o = 0; o < icc.length; o++) {
        icc[o].addEventListener("click", function () {
            this.classList.toggle("active");
            var panel = this.nextElementSibling;
            panel.classList.toggle("panel-active");
        });
    }

    //   var filter = document.getElementsByClassName("samping");
    //   var j;

    //   for (j = 0; j < filter.length; j++) {
    //     filter[j].addEventListener("click", function() {

    //       var panel = this.nextElementSibling;
    //       if (panel.style.maxHeight){
    //         panel.style.maxHeight = null;
    //       } else {
    //         let active = document.querySelectorAll(".filterna-samping .samping.active");
    //         for(let j = 0; j < active.length; j++){
    //           active[j].classList.remove("active");
    //           active[j].nextElementSibling.style.maxHeight = null;
    //         }
    //         this.classList.toggle("active");
    //         panel.classList.toggle('panel-active')
    //         panel.style.maxHeight = panel.scrollHeight + "px";
    //       }
    //     });
    //   }

    $("#apply").on("click", function () {
        var filterna = [];
        $(".filter-checkbox").each(function () {
            if ($(this).is(":checked")) {
                filterna.push($(this).attr("tags"));
            }
        });
        var indexna = $(this).attr("data-url");
        //   console.log(filterna.join("+"))
        location.href = indexna + "/" + filterna.join("+");
    });

    $("#reset").on("click", function () {
        var indexna = $(this).attr("data-url");
        location.href = indexna;
    });

    $("#detail").click(function () {
        $("body").css("overflow", "hidden");
        $("#sidebar-description").addClass("Drawer--show");
        $(".PageOverlay").addClass("is-visible");
    });

    $("#close-detail").click(function () {
        $("body").css("overflow", "auto");
        $("#sidebar-description").removeClass("Drawer--show");
        $(".PageOverlay").removeClass("is-visible");
    });

    //   var product_id = $('#variant-id').val()
    //   $('.btn--pre-order').click(function(){
    //     var test = jQuery.post('/cart/add.js', $('form[action="/cart/add"]').serialize());
    //     console.log(test)
    //   })

    if ($("#AjaxinateLoop").length) {
        let current_url = location.href;

        if (current_url.includes("collections/all")) {
            var clickPagination = setInterval(() => {
                if ($("#AjaxinatePagination a").length) {
                    $("#AjaxinatePagination a")[0].click();
                    $(".all-product-here").append($(".soldout-card"));
                }

                if ($("#AjaxinatePagination").html() == "") {
                    clearInterval(clickPagination);
                }
            }, 500);
        }
    }

    if ($(".Product__SlideItem--video").length) {
        const video = document.getElementById("product-video");
        video.addEventListener("click", function () {
            if (video.paused) {
                video.play();
            } else {
                video.pause();
            }
        });
    }

    $(".currency-switcher").click(function () {
        let currentCurrency = $(".currency-switcher .option").hasClass("open");
        if (currentCurrency) {
            $(".currency-switcher .option").removeClass("open");
            $(".currency-switcher .option").addClass("hide");
        } else {
            $(".currency-switcher .option").removeClass("hide");
            $(".currency-switcher .option").addClass("open");
        }
    });

    $(".currency-switcher .option li[currency='IDR']").click(function () {
        $(".currentCurrency span").html("IDR");
        localStorage.setItem("currencySelected", "IDR");
        chnagePriceToIDR();
    });

    $(".currency-switcher .option li[currency='USD']").click(function () {
        $(".currentCurrency span").html("USD");
        localStorage.setItem("currencySelected", "USD");
        let usd = $("body").attr("usd");
        chnagePriceToUSD(usd);
    });

    function onGetUSDCurrency() {
      console.log('currency')
        fetch(
            "https://paypal-duma.shopify-plugin.devbdd.com/index.php/paypal/getCurrencyUSD?shop=duma-id.myshopify.com"
        )
            .then((res) => res.json())
            .then((data) => {
                $("body").attr("usd", data);
                let currencySelected = localStorage.getItem("currencySelected");
                setTimeout(() => {
                    if (currencySelected != null) {
                        if (currencySelected === "IDR") {
                            $(".currentCurrency span").html("IDR");
                            chnagePriceToIDR();
                        } else {
                            $(".currentCurrency span").html("USD");
                            chnagePriceToUSD(data);
                        }
                    } else {
                        let currency = $(".currentCurrency span").html();
                        if (currency == "USD") {
                            chnagePriceToUSD(data);
                        } else {
                            chnagePriceToIDR();
                        }
                    }
                }, 1000);
            });
    }

function chnagePriceToUSD(usd) {
    $(".field-money").each(function () {
        const money = $(this).attr("price");
        const convert = Number(money) / 100 / Number(usd);
        const formatted = formatUSD(convert);
        if ($(this).text() !== formatted) {
            $(this).text(formatted);
        }
    });
}


function chnagePriceToIDR() {
    $(".field-money").each(function () {
        const money = $(this).attr("price");
        const formatted = formatIDR(Number(money) / 100);
        if ($(this).text() !== formatted) {
            $(this).text(formatted);
        }
    });
}


    function formatUSD(num) {
        return "$" + num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
    }

    function formatIDR(num) {
        return "Rp " + num.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    onGetUSDCurrency();

  function safeGetCurrencySelected() {
      try {
          return localStorage.getItem("currencySelected");
      } catch (e) {
           return currency = $(".currentCurrency span").html();
      }
  }

let currencyApplied = false;

// Fungsi debounce
function debounce(func, wait) {
    let timeout;
    return function () {
        clearTimeout(timeout);
        timeout = setTimeout(func, wait);
    };
}

function loadCurrency() {
    setTimeout(() => {
        let usdPrice = $("body").attr("usd");
        if (safeGetCurrencySelected() == "USD") {
            chnagePriceToUSD(usdPrice);
        } else {
            chnagePriceToIDR();
        }
        currencyApplied = true;
    }, 100);
}

const debouncedLoadCurrency = debounce(loadCurrency, 200);

const target = document.querySelector("#sidebar-cart");

if (target) {
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (
                mutation.attributeName === "aria-hidden"
            ) {
                const isVisible = target.getAttribute("aria-hidden") === "false";

                if (isVisible && !currencyApplied) {
                    debouncedLoadCurrency(); // hanya saat cart dibuka
                }

                if (!isVisible) {
                    currencyApplied = false; // reset flag saat cart ditutup
                }
            }

            if (
                mutation.type === "childList" ||
                mutation.type === "subtree"
            ) {
                debouncedLoadCurrency(); // untuk quantity changes, dsb.
            }
        });
    });

    observer.observe(target, {
        attributes: true,
        attributeFilter: ["aria-hidden"],
        childList: true,
        subtree: true,
    });
}

});

function openTab(evt, tabName) {
  const tablinks = document.querySelectorAll('.tablink');
  const tabcontents = document.querySelectorAll('.tabcontent');

  tabcontents.forEach(tab => tab.classList.remove('active'));
  tablinks.forEach(link => link.classList.remove('active'));

  document.getElementById(tabName).classList.add('active');
  evt.currentTarget.classList.add('active');
}


// start 
document.addEventListener("DOMContentLoaded", function () {
  const scroller = document.querySelector(".Product__SlideshowNavScroller");
  const prevBtn = document.querySelector(".ThumbNav-btn--prev");
  const nextBtn = document.querySelector(".ThumbNav-btn--next");

  if (scroller && prevBtn && nextBtn) {
    const item = scroller.querySelector(".Product__SlideshowNavImage");

    if (item) {
      const itemWidth =
        item.offsetWidth + parseInt(getComputedStyle(scroller).gap || 0);

      // tombol panah
      prevBtn.addEventListener("click", () => {
        scroller.scrollBy({ left: -itemWidth, behavior: "smooth" });
      });

      nextBtn.addEventListener("click", () => {
        scroller.scrollBy({ left: itemWidth, behavior: "smooth" });
      });

      // gesture swipe (mobile)
      let startX = 0;
      scroller.addEventListener("touchstart", (e) => {
        startX = e.touches[0].clientX;
      });

      scroller.addEventListener("touchend", (e) => {
        const endX = e.changedTouches[0].clientX;
        const deltaX = endX - startX;

        if (Math.abs(deltaX) > 50) {
          if (deltaX < 0) {
            // swipe kiri -> next
            scroller.scrollBy({ left: itemWidth, behavior: "smooth" });
          } else {
            // swipe kanan -> prev
            scroller.scrollBy({ left: -itemWidth, behavior: "smooth" });
          }
        }
      });
    }
  }
});



document.addEventListener("DOMContentLoaded", function () {
  const thumbs = document.querySelectorAll(".Product__SlideshowNavImage");

  thumbs.forEach((thumb) => {
    thumb.addEventListener("mouseenter", function () {
      thumb.click(); // trigger klik otomatis saat hover
    });
  });
});
document.addEventListener("DOMContentLoaded", function() {
  // Ambil semua scroller
  document.querySelectorAll(".Product__SlideshowNavScroller").forEach((scroller) => {
    // Ambil nilai CSS variable --thumb-count
    const thumbCount = parseInt(getComputedStyle(scroller).getPropertyValue('--thumb-count'));

    if (!isNaN(thumbCount) && thumbCount <= 5) {
      // Cari tombol navigasi dalam parent container
      const container = scroller.closest(".Product__Gallery");
      if (container) {
        const nextBtn = container.querySelector(".ThumbNav-btn--next");
        const prevBtn = container.querySelector(".ThumbNav-btn--prev");

        if (nextBtn) nextBtn.style.display = "none";
        if (prevBtn) prevBtn.style.display = "none";
      }
    }
  });
});
